import React from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Row, Col, Progress } from "reactstrap";

const Overview = ({ project }: any) => {
  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <Row>
            <Col xl={3} sm={6}>
              <Card className="border shadow-none">
                <CardBody>
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-3">
                      <div className="avatar-sm">
                        <div className="avatar-title bg-light text-primary rounded-circle font-size-18">
                          <i className="uil uil-list-ul"></i>
                        </div>
                      </div>
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="mb-1 text-truncate text-muted">Total de Tarefas</p>
                      <h5 className="font-size-16 mb-0">{project.tasks.length}</h5>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} sm={6}>
              <Card className="border shadow-none">
                <CardBody>
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-3">
                      <div className="avatar-sm">
                        <div className="avatar-title bg-light text-primary rounded-circle font-size-18">
                          <i className="uil uil-check-circle"></i>
                        </div>
                      </div>
                    </div>

                    <div className="flex-grow-1 overflow-hidden">
                      <p className="mb-1 text-truncate text-muted">Tarefas Concluídas</p>
                      <h5 className="font-size-16 mb-0">{
                          project.tasks.filter(
                            (task: any) => task.status === "CONCLUIDO"
                          ).length
                        }
                      </h5>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} sm={6}>
              <Card className="border shadow-none">
                <CardBody>
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-3">
                      <div className="avatar-sm">
                        <div className="avatar-title bg-light text-primary rounded-circle font-size-18">
                          <i className="uil uil-users-alt"></i>
                        </div>
                      </div>
                    </div>

                    <div className="flex-grow-1 overflow-hidden">
                      <p className="mb-1 text-truncate text-muted">Equipa</p>
                      <h5 className="font-size-16 mb-0">{project.unidade_name}</h5>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} sm={6}>
              <Card className="border shadow-none">
                <CardBody>
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-3">
                      <div className="avatar-sm">
                        <div className="avatar-title bg-light text-primary rounded-circle font-size-18">
                          <i className="uil uil-user"></i>
                        </div>
                      </div>
                    </div>

                    <div className="flex-grow-1 overflow-hidden">
                      <p className="mb-1 text-truncate text-muted">Responsável</p>
                      <Link to={`/users/${project.responsavel}`}>
                        <h5 className="font-size-16 mb-0">{project.responsavel_name}</h5>
                      </Link>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xl={8}>
              <Card className="border shadow-none h-100 mb-lg-0">
                <CardBody>
                  <h5 className="card-title mb-4">Descrição</h5>
                  <div className="text-muted">{project.descricao}</div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={4}>
              <Card className="border shadow-none h-100 mb-lg-0">
                <CardBody>
                  <h5 className="card-title mb-3">Fases</h5>
                  <div>
                    {project.phases.map((phase: any) => {
                      const tasksInPhase = project.tasks.filter((task: any) => task.phase === phase.id);
                      const completedTasks = tasksInPhase.filter((task: any) => task.status === "CONCLUIDO").length;
                      return (
                        <div className="py-3" key={phase.id}>
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <h5 className="font-size-14">{phase.nome}</h5>
                            </div>
                            <div className="flex-shrink-0">
                              <p className="text-muted mb-0">{completedTasks}/{tasksInPhase.length}</p>
                            </div>
                          </div>
                          <Progress
                            value={(completedTasks / tasksInPhase.length) * 100}
                            className="animated-progess custom-progress mt-2"
                          ></Progress>
                        </div>
                      );
                    })}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default Overview;
